import { render, staticRenderFns } from "./app-bottom-nav.vue?vue&type=template&id=3abf6b6f&scoped=true&"
import script from "./app-bottom-nav.vue?vue&type=script&lang=js&"
export * from "./app-bottom-nav.vue?vue&type=script&lang=js&"
import style0 from "./app-bottom-nav.vue?vue&type=style&index=0&id=3abf6b6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf6b6f",
  null
  
)

export default component.exports